export const translateX = (element: HTMLElement, value: number) =>
  (element.style.transform = `translate3d(${value}px, 0, 0)`)
